import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import _ from 'lodash';
import { useMemo } from 'react';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { pure } from 'recompose';
import parse from 'url-parse';
import v4 from 'uuid';
import { ExternalLink } from '@/components/functional/Link/ExternalLink';
import TargetBlankIcon from '@/container/Icon/Svg/TargetBlankIcon';
import HtmlLink from '@/container/Ui/Common/HtmlLink';
import Hover from '@/container/Ui/System/Hover';
import { propBool, propFunc, propStr } from '@/helpers/custom-prop-types';
import { getText, getParentNodeName, getChildrenElements, } from '@/helpers/html_parser';
const ProffitSearchLandingPageQuestionHtmlParser = pure((props) => {
    const { content, enableProffitSearch, onClickHelpLink, onClickScrollTo, onClickTrialLink, } = props;
    return useMemo(() => {
        const listStyles = [
            { className: '', prefix: '※' },
            { className: 'is-dot', prefix: '・' },
            { className: 'is-square', prefix: '■' },
            { className: 'is-rhombus', prefix: '◆' },
        ];
        const allowHref = ['TRIAL', 'SCROLL_TO_SECURITY', 'HELP'];
        const transform = (node, index) => {
            let setKey = null;
            const key = () => {
                if (!setKey) {
                    setKey = v4();
                }
                return setKey;
            };
            if (node.type === 'tag') {
                const isNodeLink = node.name === 'a' &&
                    node.attribs.href &&
                    (node.attribs.href.indexOf('http') === 0 ||
                        node.attribs.href.indexOf('/') === 0 ||
                        allowHref.includes(node.attribs.href));
                const parentNodeName = getParentNodeName(node);
                if (isNodeLink) {
                    const childElement = getChildrenElements(node, transform);
                    const { href } = node.attribs;
                    const parseData = parse(href);
                    const isOtherDomain = parseData.host !== window.location.host;
                    if (parentNodeName === 'figure') {
                        if (isOtherDomain) {
                            _.set(node, 'attribs.target', '_blank');
                            _.set(node, 'attribs.rel', 'noopener noreferrer');
                        }
                    }
                    else {
                        // 外部リンクの場合
                        if (isOtherDomain) {
                            return (_jsx(Hover, { children: _jsxs(ExternalLink, Object.assign({ href: href, target: '_blank' }, { children: [childElement, _jsx(TargetBlankIcon, {})] })) }, key()));
                        }
                        // Proffit Searchへのリンクの場合
                        if (href.indexOf('/proffit_search') === 0) {
                            return (_jsx(Hover, { children: _jsx(HtmlLink, Object.assign({ className: enableProffitSearch ? 'link-text' : '', isNoLinkComponent: enableProffitSearch ? undefined : 'span', target: '_blank', to: href }, { children: childElement })) }, key()));
                        }
                        switch (href) {
                            case 'TRIAL':
                                return (_jsx(Hover, { children: _jsx(HtmlLink, Object.assign({ className: 'link-text', isNoLinkComponent: onClickTrialLink ? 'button' : undefined, onClick: onClickTrialLink, to: '/mypage' }, { children: childElement })) }, key()));
                            case 'SCROLL_TO_SECURITY':
                                return (_jsx(Hover, { children: _jsx("button", Object.assign({ className: 'link-text', onClick: onClickScrollTo, type: 'button', value: 'proffit_search_landing_page_securities' }, { children: childElement })) }, key()));
                            case 'HELP':
                                return (_jsx(Hover, { children: _jsx("button", Object.assign({ className: 'link-text', onClick: onClickHelpLink, type: 'button' }, { children: childElement })) }, key()));
                            default:
                                return (_jsx(Hover, { children: _jsx(HtmlLink, Object.assign({ className: 'link-text', target: '_blank', to: href }, { children: childElement })) }, key()));
                        }
                    }
                }
            }
            if (node.name === 'p') {
                const text = getText(node);
                const prefix = text.charAt(0);
                const listStyle = listStyles.find((v) => v.prefix === prefix);
                if (listStyle) {
                    const newNode = node;
                    newNode.children[0].data = text.slice(1).trim();
                    return (_jsx("div", Object.assign({ className: clsx('text-liststyle', listStyle.className) }, { children: _jsx("span", { children: convertNodeToElement(newNode, index, transform) }) }), key()));
                }
            }
            if (node.name === 'li') {
                const text = getText(node);
                const prefix = text.charAt(0);
                if (listStyles.some((v) => v.prefix === prefix)) {
                    const newNode = node;
                    newNode.children[0].data = text.slice(1).trim();
                    return convertNodeToElement(newNode, index, transform);
                }
                return (_jsx("li", Object.assign({ className: 'text-liststyle is-dot' }, { children: _jsx("div", { children: text }) }), key()));
            }
            return undefined;
        };
        return ReactHtmlParser(content, { transform });
    }, [
        content,
        enableProffitSearch,
        onClickHelpLink,
        onClickScrollTo,
        onClickTrialLink,
    ]);
});
ProffitSearchLandingPageQuestionHtmlParser.propTypes = {
    content: propStr().isRequired,
    enableProffitSearch: propBool().isRequired,
    onClickHelpLink: propFunc().isRequired,
    onClickScrollTo: propFunc().isRequired,
    onClickTrialLink: propFunc(),
};
ProffitSearchLandingPageQuestionHtmlParser.defaultProps = {
    onClickTrialLink: undefined,
};
export default ProffitSearchLandingPageQuestionHtmlParser;
